import React from 'react';
import DatasetConvertDataAction from './DatasetConvertDataAction';
import DatasetValidateDataAction from './DatasetValidateDataAction';
import Selectors from '../hooks/selectors';

const DataManagementActions = ({ category, code }) => {
  const {
    allowValidate, allowConversion, conversionEnabled, datasetName,
  } = Selectors.useDataManagementActions(category, code);

  return (
    <>
      <DatasetValidateDataAction category={category} code={code} disabled={!allowValidate} />
      {allowConversion && (
        <DatasetConvertDataAction category={category} code={code} name={datasetName} disabled={!conversionEnabled} />
      )}
    </>
  );
};

export default DataManagementActions;
